// removed by extract-text-webpack-plugin
module.exports = {"form_wrapper":"gQbkD","form_name":"_2vR4B","form_select":"GxP9g","form_select_dropdown":"_1m_yB","form_input":"P6lJA","form_btn_wrapper":"_2zxwR","form_collapse":"_280_G","table_ui":"_3R05e","table_add":"eSwco","table_delete":"_1R94u","root":"_2VUgN","header":"_2vxOA","headline":"uP1AW","subtitle":"_1DRkH","headline_cont":"bh0Ls","headline__btn":"_2sGA5 _12TwT _3gxMh","headline__icon":"_3TT6Z","input_wrapper":"_2mP-p gQbkD","input_name":"_1wgx5 _1I1NP","table":"_24prA _300jB","delete":"_2EIrQ _1R94u"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/contacts/User.css
// module id = 924
// module chunks = 0